import { render, staticRenderFns } from "./price-step.vue?vue&type=template&id=d53023bc&scoped=true&"
import script from "./price-step.vue?vue&type=script&lang=js&"
export * from "./price-step.vue?vue&type=script&lang=js&"
import style0 from "./price-step.vue?vue&type=style&index=0&id=d53023bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53023bc",
  null
  
)

export default component.exports